function isContainerQuerySelector(property) {
  return property.substring(0, 10) === '@container';
}

export { isContainerQuerySelector };
//# sourceMappingURL=isContainerQuerySelector.esm.js.map
